import { NotificationDto } from '@interfaces/models';
import { create } from 'zustand';

export interface NotificationsListStore {
  selectedNotification: NotificationDto | null;
  isRemoveNotificationDialogOpen: boolean;
  setSelectedNotification: (notification: NotificationDto | null) => void;
  setIsRemoveNotificationDialogOpen: (isOpen: boolean) => void;
}

export const useNotificationsListStore = create<NotificationsListStore>((set) => ({
  isRemoveNotificationDialogOpen: false,
  selectedNotification: null,
  setIsRemoveNotificationDialogOpen: (isOpen) => set({ isRemoveNotificationDialogOpen: isOpen }),
  setSelectedNotification: (notification: NotificationDto | null) =>
    set({ selectedNotification: notification }),
}));
